export default function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}


//////////////////
// WEBPACK FOOTER
// C:/Users/Taras/Local Sites/nec/app/public/wp-content/themes/nec/node_modules/swiper/esm/components/core/translate/maxTranslate.js
// module id = 187
// module chunks = 0